import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { IoLogOutOutline, IoMenuOutline } from 'react-icons/io5';
import './Header.css';

const Header = ({ onMenuClick }) => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <header className="header">
      <div className="header-left">
        {onMenuClick && (
          <button className="header-menu-btn" onClick={onMenuClick} aria-label="Open menu">
            <IoMenuOutline className="menu-icon" />
          </button>
        )}
        <div className="header-brand">
          <span className="greeting">Welcome Back!</span>
          <span className="sub-greeting">
            {user?.role?.toLowerCase() === 'admin'
              ? 'Admin Panel'
              : user?.role?.toLowerCase() === 'engineer'
              ? 'Engineer Panel'
              : 'NextStep Support'}
          </span>
        </div>
      </div>
      <div className="header-right">
        <span className="user-name">{user?.name || 'User'}</span>
        <button className="logout-btn" onClick={handleLogout} title="Logout">
          <IoLogOutOutline className="logout-icon" />
          <span>Logout</span>
        </button>
      </div>
    </header>
  );
};

export default Header;
